module.exports = __webpack_public_path__ + "media/images/shared/icon_googleplus-7cae8688c602963ad4b2e69456c88f99.png";